const getFileNameFromUrl = (url?: string) =>
  decodeURIComponent(url?.split('/').pop()?.slice(37) || 'Arquivo');

export default getFileNameFromUrl;
